import React from 'react';

const CATEGORIAS = [
  { id: 'operario', nombre: 'Operario' },
  { id: 'oficial', nombre: 'Oficial' },
  { id: 'peon', nombre: 'Peón' },
];

const ConstruccionCivilFichaEmpleado = ({ ficha, onChange }) => {
  const setCampo = (campo, valor) => onChange({ ...ficha, [campo]: valor });

  return (
    <>
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-teal-700">Categoría CONSU:</label>
        <select
          className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm w-40"
          value={ficha.categoria}
          onChange={(e) => setCampo('categoria', e.target.value)}
        >
          {CATEGORIAS.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
        </select>
      </div>
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-teal-700">Beneficios:</label>
        <select
          className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm w-48"
          value={ficha.modalidad_beneficios}
          onChange={(e) => setCampo('modalidad_beneficios', e.target.value)}
        >
          <option value="sin_beneficios">Sin beneficios embebidos</option>
          <option value="con_beneficios">Con beneficios en el periodo</option>
        </select>
      </div>
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-teal-700">Salud:</label>
        <select
          className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm w-40"
          value={ficha.afiliacion_salud}
          onChange={(e) => setCampo('afiliacion_salud', e.target.value)}
        >
          <option value="essalud">EsSalud (9%)</option>
          <option value="eps">EPS (6.75%)</option>
        </select>
      </div>
      <label className="flex items-center gap-2 pb-1 text-sm text-gray-700">
        <input
          type="checkbox"
          checked={!!ficha.escolaridad_pago_mensual}
          onChange={(e) => setCampo('escolaridad_pago_mensual', e.target.checked)}
        />
        Escolaridad mensual
      </label>
    </>
  );
};

export default ConstruccionCivilFichaEmpleado;
